module.exports = __webpack_public_path__ + "static/img/thing.3fcdaa61.png";